(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/event-number.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/event-number.js');
"use strict";

const useWagerCurrentCorrectValues = svs.components.tipsen.hooksWager.useWagerCurrentCorrectValues;
const _svs$components$sport = svs.components.sport.tipsenShared,
  MatchCorrectStatus = _svs$components$sport.constants.MatchCorrectStatus,
  TipsenModuleGameUrl = _svs$components$sport.TipsenModuleGameUrl;
const _svs$components$tipse = svs.components.tipsen.matchNumberIcon,
  MatchNumberIcon = _svs$components$tipse.MatchNumberIcon,
  _svs$components$tipse2 = _svs$components$tipse.constants,
  matchNumberTextColor = _svs$components$tipse2.matchNumberTextColor,
  matchCorrectStatusColor = _svs$components$tipse2.matchCorrectStatusColor;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const Badge = svs.ui.ReactBadge;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const MatchNumber = _ref => {
  let _ref$isCompressed = _ref.isCompressed,
    isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed,
    eventNumber = _ref.eventNumber,
    branding = _ref.branding;
  const location = useLocation();
  const isResult = location.pathname.includes("/".concat(TipsenModuleGameUrl.RESULT));
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  if (!isResult && (isSmall || isCompressed)) {
    return React.createElement("div", {
      className: "pg_coupon_static__event_number f-medium"
    }, "".concat(eventNumber, "."));
  }
  return React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(Badge, {
    branding: branding
  }, eventNumber));
};
const EventNumber = _ref2 => {
  let drawResult = _ref2.drawResult,
    eventNumber = _ref2.eventNumber,
    _ref2$eventTypeId = _ref2.eventTypeId,
    eventTypeId = _ref2$eventTypeId === void 0 ? 1 : _ref2$eventTypeId,
    _ref2$userRow = _ref2.userRow,
    userRow = _ref2$userRow === void 0 ? [] : _ref2$userRow,
    bestBetRowResult = _ref2.bestBetRowResult,
    _ref2$isCompressed = _ref2.isCompressed,
    isCompressed = _ref2$isCompressed === void 0 ? false : _ref2$isCompressed,
    branding = _ref2.branding;
  const rowCorrectStatus = useWagerCurrentCorrectValues({
    drawResult,
    eventNumber,
    eventTypeId,
    userRow,
    bestBetRowResult
  });
  const gameIcon = 'game-soccer'; 
  let iconColor;
  switch (rowCorrectStatus) {
    case MatchCorrectStatus.NOT_CORRECT:
      iconColor = matchCorrectStatusColor.NOT_CORRECT;
      break;
    case MatchCorrectStatus.CORRECT:
      iconColor = matchCorrectStatusColor.CORRECT;
      break;
    case MatchCorrectStatus.POSSIBLE_WIN:
      iconColor = matchCorrectStatusColor.POSSIBLE_WIN;
      break;
    default:
      iconColor = matchCorrectStatusColor.NONE;
  }
  if (eventTypeId !== EventTypeId.GOAL_COUNT || isCompressed) {
    return React.createElement(MatchNumber, {
      branding: branding,
      eventNumber: eventNumber,
      isCompressed: isCompressed
    });
  }
  return React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(MatchNumberIcon, {
    color: iconColor,
    icon: gameIcon,
    text: eventNumber.toString(),
    textColor: matchNumberTextColor.WHITE
  }));
};
setGlobal('svs.components.tipsen.couponStatic.EventNumber', EventNumber);

 })(window);